<template>
  <div class="editor-panel">
    <h1 v-if="title" class="editor-panel__title">{{ title }}</h1>
    <p v-if="subtitle" class="editor-panel__subtitle menu-text">{{ subtitle }}</p>

    <div class="editor-panel__body">
      <slot />
    </div>

    <div class="editor-panel__actions">
      <!-- Slot con fallback: si el hijo no inyecta nada en #actions,
           se muestra el botón de confirmación por defecto. Si el hijo
           necesita múltiples botones (ej: EditorCardPanel), los inyecta
           y el fallback desaparece automáticamente. -->
      <slot name="actions">
        <v-btn
          outlined
          class="text-black rounded-md py-4 px-10 editor-panel__confirm-btn"
          small
          :loading="loadingSave"
          :disabled="loadingSave || disabled"
          :aria-label="confirmAriaLabel || 'harmony.confirm'"
          @click="$emit('confirm')"
        >
          <v-icon center aria-hidden="true">{{ confirmIcon || 'mdi-check-bold' }}</v-icon>
        </v-btn>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditorPanel',
  props: {
    title: { type: String, default: null },
    subtitle: { type: String, default: null },
    loadingSave: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    confirmIcon: { type: String, default: null },
    confirmAriaLabel: { type: String, default: null },
  },
}
</script>

<style scoped>
.editor-panel {
  padding: var(--editor-space-3) var(--editor-space-2) var(--editor-space-3);
}

.editor-panel__title {
  font-size: var(--editor-font-size-label);
  color: var(--editor-color-label);
  text-align: center;
  margin: 0 0 var(--editor-space-3);
  font-weight: 400;
}

.editor-panel__subtitle {
  font-size: var(--editor-font-size-label);
  color: var(--editor-color-label);
  text-align: left;
  margin: var(--editor-space-1) 0 var(--editor-space-2);
  font-weight: 400;
}

.editor-panel__body {
  margin: 0;
}

.editor-panel__actions {
  display: flex;
  justify-content: center;
  margin-top: var(--editor-space-4);
  padding: 0 0 var(--editor-space-2);
}

.editor-panel__confirm-btn {
  color: var(--editor-color-primary) !important;
  border-color: var(--editor-color-primary) !important;
  caret-color: var(--editor-color-primary) !important;
}
</style>
